import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { SlideFrame } from '../SlideFrame';
import { proofPoints } from '../../data/deckContent';
export function ProofSlide() {
  const reduced = useReducedMotion();
  return <SlideFrame eyebrow="Two proof points" index={5} data-id="element-103" data-mp="1311jxr5vgo9u">
      <div data-id="element-104" data-mp="y41cpcxadfh5">
        <h2 className="text-[clamp(24px,3.4vw,60px)] font-semibold leading-[1.06] tracking-tight text-white" data-id="element-105" data-mp="y4b1wyaibils">
          Already in use.
        </h2>

        <div className="mt-[3vh] grid grid-cols-2 gap-[2vw]" data-id="element-106" data-mp="u40ztwpu5cc7">
          {proofPoints.map((point, i) => <motion.article key={point.product} initial={reduced ? false : {
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4,
          delay: 0.08 * i,
          ease: 'easeOut'
        }} className="rounded-[1.6vw] border border-white/10 bg-white/[0.04] p-[2.2vw]" data-id="element-107" data-mp="p9d5vic2bpq8" data-mpi={i}>
              <p className="text-[clamp(10px,0.95vw,18px)] uppercase tracking-[0.28em] text-[color:var(--sv-green)]" data-id="element-108" data-mp="6dn51yfv8zdx">
                {point.product}
              </p>
              <p className="mt-[2vh] text-[clamp(11px,1.05vw,20px)] font-light text-white/50" data-id="element-109" data-mp="38s5srhrd4eag">
                {point.invested} →
              </p>
              <p className="mt-[0.6vh] text-[clamp(34px,4.6vw,82px)] font-semibold leading-none tracking-tight text-white" data-id="element-110" data-mp="2u4kr7sa4yn4n">
                {point.returned}
              </p>
              <p className="mt-[1.4vh] text-[clamp(11px,1.2vw,22px)] font-light leading-snug text-white/60" data-id="element-111" data-mp="3msglyrg5a4ys">
                {point.detail}
              </p>
            </motion.article>)}
        </div>

        <p className="mt-[3vh] text-[clamp(12px,1.35vw,26px)] font-light text-white/70" data-id="element-112" data-mp="3dpz0if8bdgcu">
          Same format. Different product.{' '}
          <span className="font-medium text-[color:var(--sv-green)]" data-id="element-113" data-mp="3hu6qefqid2cn">
            Same Solventum promise.
          </span>
        </p>
      </div>
    </SlideFrame>;
}